var $846eaea7e21f7fbf$exports = {};
$846eaea7e21f7fbf$exports = {
    "pending": `\u{10D}akaj\xface`
};


export {$846eaea7e21f7fbf$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
